export class Tag {
  tagId: number;
  tagRefId: number;
  tagName: string;
  description: string;
}
